import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export function ErrorPanel({ onRetry, onBack, issue }) {
  const unavailable = !issue;
  return (
    <section className="flex flex-col items-center justify-center min-h-[calc(100dvh-57px)] px-5 py-8 text-center lg:max-w-xl lg:mx-auto"
      role="alert" data-testid={unavailable ? "unavailable-panel" : "document-error-panel"}>
      <AlertTriangle className="w-10 h-10 text-marianne-blue" aria-hidden="true" />
      <h2 className="font-head text-2xl font-bold text-marianne mt-5">
        {unavailable ? "Marianne est momentanément indisponible" : issue.title}
      </h2>
      <p className="text-lg text-gray-600 mt-3 leading-relaxed">
        {unavailable ? "Réessayez dans quelques minutes." : issue.message}
      </p>
      <button onClick={unavailable ? onRetry : onBack} data-testid="error-action"
        className="mt-6 w-full min-h-[60px] rounded-full bg-marianne text-white font-head font-bold text-lg flex items-center justify-center gap-2">
        {unavailable && <RefreshCw className="w-5 h-5" aria-hidden="true" />}
        {unavailable ? "Réessayer" : "Choisir un autre fichier"}
      </button>
      {unavailable && onBack && (
        <button onClick={onBack} className="mt-4 text-marianne underline underline-offset-4 font-medium">Retour</button>
      )}
    </section>
  );
}
